import { uploadingStateInjectionKey } from '@/components/forms/useVeeForm';
import { useFieldError, useValidateField } from 'vee-validate';
import { inject, Ref, watch, watchEffect } from 'vue';

interface UseUploadValidationProps {
  name: Ref<string>;
  isUploadRunning: Ref<boolean>;
  isUploadError: Ref<boolean>;
}

export function useUploadValidation({
  isUploadRunning,
  isUploadError,
  name,
}: UseUploadValidationProps) {
  const uploadingState = inject(uploadingStateInjectionKey);

  const errorMessage = useFieldError(name);
  const validate = useValidateField(name);

  // needs a validation()-trigger to remove the errorMessage when valid
  watchEffect(async () => {
    if (!isUploadError.value && !isUploadRunning.value && errorMessage.value) {
      await validate();
    }
  });

  // Report upload state to parent form using Map-based tracking
  watch(
    isUploadRunning,
    (uploadRunning) => {
      if (uploadingState) {
        if (uploadRunning) {
          uploadingState.addUploadRunning(name.value);
        } else {
          uploadingState.removeUploadRunning(name.value);
        }
      }
    },
    { immediate: true },
  );

  watch(
    isUploadError,
    (uploadError) => {
      if (uploadingState) {
        if (uploadError) {
          uploadingState.addUploadError(name.value);
        } else {
          uploadingState.removeUploadError(name.value);
        }
      }
    },
    { immediate: true },
  );
}
